import React from 'react';
import Button from '../../../../../components/Button';
import { ACCOUNT_SELLER_STATUS } from '../../../../../constants/service/app/accountSellerConstants';
import './BrandDetailInfoHeader.scss';

const BrandDetailInfoHeader = (props) => {
  const { storeId, status, isEditable, setData, permitBrand, onSubmit, edit, cancelEdit } = props;

  return (
    <div className="brandDetailInfoHeader">
      {isEditable ? (
        <div className="buttons">
          {/*편집기능 실행*/}
          <Button color="primary" text="저장하기" onClick={onSubmit} />

          {/*상세 페이지로 이동하기*/}
          <Button text="취소하기" onClick={cancelEdit} />
        </div>
      ) : (
        <div className="buttons">
          {/*가입요청 상태일 때만 승인페이지로 이동 가능*/}
          {status === ACCOUNT_SELLER_STATUS.REQUEST ? (
            <div className="">
              {/*승인하기 기능 실행*/}
              <Button color="primary" text="승인하기" onClick={() => permitBrand(storeId)} />

              {/*거절하기 기능 실행*/}
              <Button
                color="red"
                text="거절하기"
                onClick={() => {
                  setData({
                    path: ['rejectBrandModal', 'isOpen'],
                    value: true,
                  });
                  setData({
                    path: ['rejectBrandModal', 'data', 'storeId'],
                    value: storeId,
                  });
                }}
              />
              <Button type="button" color="gray" text="편집하기" onClick={edit} />
            </div>
          ) : (
            <Button type="button" color="primary" text="편집하기" onClick={edit} />
          )}
        </div>
      )}
    </div>
  );
};

export default BrandDetailInfoHeader;
